import { Text } from "@chakra-ui/react";
import React from "react";
import { ContactSupport } from "../molecules/ContactSupport";

export const UnexpectedErrorString = "Something went wrong. Please try again.";

export const UnexpectedError = (): JSX.Element => (
  <Text color="red.500">
    {UnexpectedErrorString}
    <p>
      If issues persist, please{" "}
      <ContactSupport
        variant="link"
        colorScheme="red"
        supportPrompt={"I need some help"}
      />
      .
    </p>
  </Text>
);
